import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { GoogleSigninComponent } from '../google-signin/google-signin.component';
import { GoogleAuthService } from '../../services/google-auth.service';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, GoogleSigninComponent],
  template: `
    <div class="login-shell">
      <div class="login-card">
        <h1>MindmapsforUPSC</h1>
        <p class="subtitle">Sign in to continue</p>
        <p class="hint">Access is restricted to <strong>admin&#64;intellipreptech.com</strong></p>

        <div class="signin-slot">
          <app-google-signin
            buttonId="login-google-button"
            [buttonOptions]="{ theme: 'filled_blue', size: 'large', text: 'signin_with', shape: 'rectangular' }">
          </app-google-signin>
        </div>

        <div class="error" *ngIf="rejectionMessage">{{ rejectionMessage }}</div>
      </div>
    </div>
  `,
  styles: [`
    .login-shell {
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #1a73e8 0%, #4285f4 100%);
      padding: 24px;
    }
    .login-card {
      background: #fff;
      border-radius: 12px;
      padding: 40px 32px;
      max-width: 420px;
      width: 100%;
      box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
      text-align: center;
    }
    h1 { color: #202124; margin: 0 0 4px; }
    .subtitle { color: #5f6368; margin: 0 0 24px; }
    .hint { color: #5f6368; font-size: 14px; margin: 0 0 24px; }
    .signin-slot { display: flex; justify-content: center; padding: 12px 0 8px; }
    .error {
      margin-top: 20px;
      padding: 12px 14px;
      background: #fce8e6;
      color: #b3261e;
      border-radius: 6px;
      font-size: 14px;
      border: 1px solid #f4c7c3;
    }
  `]
})
export class LoginComponent implements OnInit, OnDestroy {
  rejectionMessage: string | null = null;
  private subs: Subscription[] = [];

  constructor(
    private auth: GoogleAuthService,
    private router: Router,
    private loading: LoadingService
  ) {}

  async ngOnInit(): Promise<void> {
    // The shared preloader stays up until the three area-loaded setters are called.
    // Login has no such areas, so dismiss them or the preloader covers the sign-in UI.
    this.loading.setSingleTreeLoaded();
    this.loading.setMainAreaLoaded();
    this.loading.setDetailsAreaLoaded();

    if (this.auth.isLoggedIn()) {
      this.router.navigate(['/home']);
      return;
    }
    this.subs.push(this.auth.rejection$.subscribe(msg => this.rejectionMessage = msg));
    this.subs.push(this.auth.authState$.subscribe(isIn => {
      if (isIn) this.router.navigate(['/home']);
    }));
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }
}
